"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownRenderer = void 0;
var react_1 = __importStar(require("react"));
var react_markdown_1 = __importDefault(require("react-markdown"));
var MarkdownRenderer = function (props) {
    var markdown = props.markdown;
    var _a = (0, react_1.useState)("Loading auction rules and conditions..."), data = _a[0], setData = _a[1];
    (0, react_1.useEffect)(function () {
        setData(markdown);
    }, [markdown]);
    return (react_1.default.createElement(react_markdown_1.default, { className: "flex flex-col gap-4 h-full", components: {
            h1: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("h1", { className: "text-2xl font-bold" }, children);
            },
            h2: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("h2", { className: "text-xl font-bold" }, children);
            },
            h3: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("h3", { className: "text-lg font-bold" }, children);
            },
            h4: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("h4", { className: "text-base font-bold" }, children);
            },
            h5: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("h5", { className: "text-sm font-bold" }, children);
            },
            h6: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("h6", { className: "text-xs font-bold" }, children);
            },
            p: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("p", { className: "text-base" }, children);
            },
            a: function (_a) {
                var children = _a.children, href = _a.href;
                return (react_1.default.createElement("a", { href: href, className: "text-blue-500 hover:underline" }, children));
            },
            ul: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("ul", { className: "list-disc pl-6" }, children);
            },
            ol: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("ol", { className: "list-decimal pl-6" }, children);
            },
            li: function (_a) {
                var children = _a.children;
                return react_1.default.createElement("li", { className: "" }, children);
            },
        } }, data));
};
exports.MarkdownRenderer = MarkdownRenderer;
